<template>
    <div>
        <div class="form__split form__split-border">
            <div class="form__split-title">
                <div class="h3 _mb-8">Проверьте данные на карте</div>
                <p class="p3 text-gray _mb-24">
                    Указанные имя и фамилия будут напечатаны на карте
                </p>
            </div>
            <div class="form__split-fields">
                <notice-attention class="_mb-32-24">
                    Проверьте написание имени и фамилии латиницей (в соответствии с указанными в заграничном паспорте). При необходимости, скорректируйте
                </notice-attention>
                <div class="form__row">
                    <div class="form__col">
                        <DInput
                            v-model.trim="$v.firstNameLatLocal.$model"
                            label="Имя"
                            name="firstNameLatLocal"
                            :error="$v.firstNameLatLocal.$error"
                            type="text"
                        >
                            <template #messages v-if="$v.firstNameLatLocal.$error">
                                <p v-if="$v.firstNameLatLocal.$error && !$v.firstNameLatLocal.required">Это поле необходимо заполнить</p>
                                <p v-if="$v.firstNameLatLocal.$error && !$v.firstNameLatLocal.diffBetweenWords">Можно изменить не более трех символов</p>
                                <p v-if="$v.firstNameLatLocal.$error && !$v.firstNameLatLocal.onlyLatSymbol">Поле должно содержать только латиницу</p>
                            </template>
                        </DInput>
                    </div>
                    <div class="form__col">
                        <DInput
                            v-model.trim="$v.lastNameLatLocal.$model"
                            label="Фамилия"
                            name="lastNameLatLocal"
                            :error="$v.lastNameLatLocal.$error"
                            type="text"
                        >
                            <template #messages v-if="$v.lastNameLatLocal.$error">
                                <p v-if="$v.lastNameLatLocal.$error && !$v.lastNameLatLocal.required">Это поле необходимо заполнить</p>
                                <p v-if="$v.lastNameLatLocal.$error && !$v.lastNameLatLocal.diffBetweenWords">Можно изменить не более трех символов</p>
                                <p v-if="$v.lastNameLatLocal.$error && !$v.lastNameLatLocal.latWithDash">Поле должно содержать только латиницу</p>
                            </template>
                        </DInput>
                    </div>
                </div>
            </div>
        </div>

        <div class="form__split form__split-nopb">
            <div class="form__split-title">
                <div class="h3 _mb-8">Придумайте кодовое слово</div>
                <p class="p3 text-gray _mb-24">
                    Кодовое слово нужно для идентификации вас при обращение в банк по телефону
                </p>
            </div>
            <div class="form__split-fields">
                <div class="form__row">
                    <div class="form__col form__col_1-1">
                        <DInput
                            v-model.trim="$v.codeWord.$model"
                            label="Кодовое слово"
                            name="codeWord"
                            :error="$v.codeWord.$error"
                            type="text"
                        >
                            <template #messages v-if="$v.codeWord.$error">
                                <p v-if="$v.codeWord.$error && !$v.codeWord.required">Это поле необходимо заполнить</p>
                                <p v-if="$v.codeWord.$error && !$v.codeWord.onlyCyr">Поле не должно содержать латинские буквы и спецсимволы</p>
                            </template>
                        </DInput>
                    </div>
                </div>

                <div class="form__group">
                    <DButton @click="sendForm" id="ym-deposit-step2" :disabled="!stepFourComplete">Продолжить</DButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { diffBetweenWords } from '../../assets/js/vue/utlis/diffBetweenWords';
import { convertToLatin } from '../../assets/js/utils';
import { onlyCyr, latWithDash } from '../../assets/js/vue/validations';
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
import { DInput } from '@ahml/domrfbank-ui/elements/DInput';


export default {
    name: 'CardsFormV2Step4',
    components: {
        DButton,
        DInput
    },
    mixins: [validationMixin],
    props: {
        lastName: {
            type: String,
            default: ''
        },
        firstName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            firstNameLat: '',
            lastNameLat: '',
            codeWord: '',
            firstNameLatLocal: '',
            lastNameLatLocal: '',
            stepFourComplete: false,
        };
    },
    computed: {
        firstNameOriginLat() {
            return convertToLatin(this.firstName).toUpperCase();
        },
        lastNameOriginLat() {
            return convertToLatin(this.lastName).toUpperCase();
        },
        formData() {
            let data = {
                data: {
                    type: "debitCard",
                    attributes: {
                        codeword: this.codeWord,
                        nameOnCard: [this.firstNameLatLocal, this.lastNameLatLocal].join(' ')
                    }
                }
            }

            return data;
        }
    },
    watch: {
        firstNameOriginLat: {
            handler(val) {
                if (this.firstNameLatLocal.length === 0) this.firstNameLatLocal = val;
                this.stepFourCompleteCheck();
            },
        },
        lastNameOriginLat: {
            handler(val) {
                if (this.lastNameLatLocal.length === 0) this.lastNameLatLocal = val;
                this.stepFourCompleteCheck();
            },
        },
        codeWord() {
            this.stepFourCompleteCheck();
        },
    },
    validations() {
        return {
            firstNameLatLocal: {
                required,
                diffBetweenWords: (val) => diffBetweenWords(this.firstNameOriginLat, val) <= 3,
                latWithDash,
            },
            lastNameLatLocal: {
                required,
                diffBetweenWords: (val) => diffBetweenWords(this.lastNameOriginLat, val) <= 3,
                latWithDash,
            },
            codeWord: { required, onlyCyr },
        };
    },
    methods: {
        stepFourCompleteCheck() {
            if (!this.$v.firstNameLatLocal.$invalid &&
                !this.$v.lastNameLatLocal.$invalid &&
                !this.$v.codeWord.$invalid
            ) {
                this.stepFourComplete = true;
            } else {
                this.stepFourComplete = false;
            }
        },
        sendForm() {
            // this.$emit('setExtraData', this.extraData);
            this.$emit('sendStep', this.formData, 4);
        },
    },
    created() {
        if (this.firstNameLat.length === 0) this.firstNameLat = this.firstNameOriginLat;
        if (this.lastNameLat.length === 0) this.lastNameLat = this.lastNameOriginLat;
    },
};
</script>
